import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { Alert, Badge, buttonVariants } from '@/components/ui'

import { isPausedForCredits, useUsageSummary } from '../queries'

/** Selo "Pausado: sem créditos" ao lado do modo do agente (o modo não muda). Só em Enforce, só sem saldo. */
export function PausedForCreditsBadge({ tenantId }: { readonly tenantId: string | undefined }) {
  const { t } = useTranslation()
  const summary = useUsageSummary(tenantId)

  if (!isPausedForCredits(summary.data)) {
    return null
  }

  return (
    <Badge variant="danger" data-testid="paused-for-credits">
      {t('billing.paused.badge')}
    </Badge>
  )
}

/** Aviso com ação na tela de Agentes quando a IA está pausada por falta de créditos. */
export function PausedForCreditsAlert({
  tenantId,
  tenantSlug,
}: {
  readonly tenantId: string | undefined
  readonly tenantSlug: string
}) {
  const { t } = useTranslation()
  const summary = useUsageSummary(tenantId)

  if (!isPausedForCredits(summary.data)) {
    return null
  }

  return (
    <Alert variant="danger" title={t('billing.paused.title')}>
      <p>{t('billing.paused.description')}</p>
      <Link
        to="/app/$tenantSlug/billing"
        params={{ tenantSlug }}
        className={buttonVariants({ variant: 'secondary', size: 'sm', className: 'mt-2' })}
      >
        {t('billing.paused.action')}
      </Link>
    </Alert>
  )
}
